/* eslint-disable complexity */
import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import momencik from '../../../common/momencik';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { ExaminedFromExamPreviewLink } from '../Examined/ExaminedFromExamPreviewLink';
import { GetCardDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import {
  ArticleMode,
  CardType,
  CardTypeText,
} from '../../../common/spdCore/validation/schemas';
import { ExamLink } from '../Judgments/ExamLink';

import { CardsLink } from './CardsLink';
import { CardPreviewLink } from './CardPreviewLink';
import { CardSignLink } from './CardSignLink';

interface CardsSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick?: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
  enableSingleSelect?: boolean;
  selectedKeys?: string[];
  withFilterInColumns?: boolean;
}

export const cardForGrid = (card: GetCardDto) => {
  return {
    key: card.id,
    values: {
      'exam.number': (
        <>
          {card?.exam?.id && (
            <ExamLink
              examId={card?.exam?.id}
              articleMode={
                (card?.type as unknown as CardType) === CardType.Psychologist ||
                (card?.type as unknown as CardType) ===
                  CardType.PsychologistWeapon
                  ? ArticleMode.Psychologist
                  : ArticleMode.Doctor
              }
            />
          )}{' '}
          {card?.exam?.number}
        </>
      ),
      'card.number': (
        <>
          {card?.exam?.id ? (
            <CardsLink
              examId={card?.exam?.id}
              type={card.type as unknown as CardType}
              newWindow={true}
            />
          ) : (
            <></>
          )}{' '}
          {card?.number || ''}
        </>
      ),
      'card.cardDate': momencik(card.cardDate),
      'card.postDate': momencik(card.postDate),
      'card.pass': card?.pass ? 'Tak' : ' Nie ',
      'examined.surname': card?.exam?.examined && (
        <>
          <ExaminedFromExamPreviewLink examId={card?.exam?.id} />{' '}
          {card?.exam.examined.surname} {card?.exam.examined.firstname}
        </>
      ),
      'examined.pesel':
        card?.exam?.examined?.pesel ||
        (card?.exam?.examined?.iDCardType || '') +
          ' ' +
          (card?.exam?.examined?.iDCardNumber || '') ||
        '',
      'card.type': card.type && CardTypeText[card.type],
      'psychologist.name': card?.psychologist?.name || '',
      'healthcareFacility.displayName':
        card?.exam?.examPackage?.healthcareFacility?.displayName || '',
      preview: <CardPreviewLink cardId={card.id} />,
      sign:
        !card.withoutSign && card.verified ? (
          <CardSignLink cardId={card.id} />
        ) : null,
    },
  };
};

export const CardsSearch: React.FC<CardsSearchProps> = props => {
  const columns = [
    { header: 'Numer badania', property: 'exam.number' },
    { header: 'Numer karty', property: 'card.number' },
    { header: 'Data karty', property: 'card.cardDate' },
    { header: 'Data wysłania', property: 'card.postDate' },
    {
      header: 'Wynik pozytywny',
      property: 'card.pass',
      noFilter: true,
    },
    { header: 'Badany', property: 'examined.surname' },
    { header: 'PESEL / dokument', property: 'examined.pesel' },
    { header: 'Placówka', property: 'healthcareFacility.displayName' },
    { header: 'Psycholog / Lekarz', property: 'psychologist.name' },
    { header: 'Typ', property: 'card.type', noSorting: true, noFilter: true },
    { header: '', property: 'preview', noSorting: true, noFilter: true },
    { header: '', property: 'sign', noSorting: true, noFilter: true },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="card.cardDate"
      initialOrderDirection="DESC"
      availablePageSizes={[10, 20, 50]}
      onRowClick={props.onRowClick}
      emptyGridMessage="Brak kart w systemie"
      refresh={props.refresh}
      enableSingleSelect={props.enableSingleSelect}
      selectedKeys={props.selectedKeys}
      withHistory={true}
      withFilterInColumns={props.withFilterInColumns}
    />
  );
};
